import React, {Component} from 'react';
import { translate, Trans } from "react-i18next";
import Form from 'react-validation/build/form';
import Input from 'react-validation/build/input';
import {required,email,isValidForm} from '../../../server/validationMethods.js'
import Draft from './draft.js';
class AddAdult extends Component {
    constructor(props){
        super(props);
        this.state={
            'hasError':false
        }
        this.validateFields=this.validateFields.bind(this)
        this.childComponentRef = React.createRef();
    }
    validateFields=()=>{
        let parentError=true;
        parentError=this.props.lunchObj.adultList.every((adult)=>{
            return adult.fname!='' && adult.lname!=''
        });
        if(parentError){
            return true
        }
        return false
    }
render(){
    const {lunchObj}=this.props
    const { t, i18n } = this.props;
    return(
        <div>
            <div className="row">
                <div className="col-xs-12 block">
                    <div className="schoolInfo">
                        <p><Trans>Okay, now let’s talk about the adults in your household</Trans>.</p>
                        <p><Trans>Not including</Trans> <strong>{this.props.lunchObj.persons[0].lname+' '+ this.props.lunchObj.persons[0].fname}</strong>, <Trans>what other adults live in the household?</Trans></p>
                        <p><Trans>Remember, for the purposes of applying for school meal benefits, a household is defined as a group of people, related or unrelated, that usually live together and share income and expenses</Trans>. <Trans>Don't forget about</Trans>:</p>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                <p><ul style={{paddingLeft:'20px'}}>
                         <li style={{listStyleType: 'disc'}}><Trans>Grandparents or other extended family members living with you</Trans></li>
                                            <li style={{listStyleType: 'disc'}}>
                                                <p><Trans>People who are temporarily away, such as:</Trans>:</p>
                                                    <ul style={{paddingLeft:'40px'}}>
                                                        <li style={{listStyleType: 'disc'}}><Trans>Children away at college,</Trans></li>
                                                        <li style={{listStyleType: 'disc'}}><Trans>Family members in the military who are deployed</Trans></li>                                
                                                   </ul>
                                            </li>
                        
                    </ul></p>
                </div>
            </div>
            <div className="row">
                <div className="col-md-12">
                    <p><string><Trans>Include people regardless of age or whether they earn or receive income</Trans>.</string></p>
                </div>
            </div>
            <Form ref={f=>this.frmPrimAdultInfo=f}>
            <div className="row">
                <div className="col-xs-12">
                <div className="row">
                <div className="col-xs-12">
                <ul>                
                {
                    this.props.lunchObj.adultList.map((adult,k)=>{
                        return(
                            <li><div className="row">
                                <div className="col-md-3" style={{paddingBottom:'10px'}}>
                                    <input type="text" data-idx={k} name="fname" className="form-control" placeholder={t('First Name')} value={adult.fname}
                                    // validations={[required]} requiredmsg='Please provide first name.' 
                                    onChange={(e)=>{
                                        let _idx=e.target.getAttribute('data-idx');
                                        this.props.onFieldValueChange(_idx,e.target.name,e.target.value)
                                    }} />
                                </div>
                                <div className="col-md-2">
                                    <input type="text" data-idx={k} name="lname" className="form-control" placeholder={t('Last Name')} value={adult.lname}
                                    // validations={[required]} requiredmsg='Please provide last name.' 
                                    onChange={(e)=>{
                                        let _idx=e.target.getAttribute('data-idx');
                                        this.props.onFieldValueChange(_idx,e.target.name,e.target.value)
                                    }} />
                                </div>
                            </div>
                            <div className="row">                                
                                <div className="col-md-2">
                                    <button type="button" data-idx={k} onClick={(e)=>{
                                        let _idx=e.target.getAttribute('data-idx');
                                        this.props.onDeleteAdult(_idx);
                                        this.childComponentRef.current.formatDraftReqObj();
                                    }} className="btn btn-xs btn-danger"> <Trans>Remove adult</Trans></button>
                                </div>                                
                            </div></li>
                        )
                    })
                }
                </ul>
                    
                </div>
            </div>
            <div className="row">
                <div className="col-md-12 text-center">
                    <button type="button" className="btn btn-xs btn-success" onClick={(e)=>{
                        this.props.onAddNewAdult();
                        this.childComponentRef.current.formatDraftReqObj();
                    }}><Trans>+ Add another adult</Trans></button>
                </div>
            </div>
                </div>
            </div>            
            </Form>
            <div className="row">
                <div className="col-md-12">
                    <p>
                    { (!this.validateFields()) && this.state.hasError? <span className="text-danger"> <Trans>Please enter all required information above</Trans>.</span>:null
                    }</p>
                </div>
            </div>
            <div className="row">
                <div className="col-xs-12">
                        <button className="btn btn-next bg-color-4 btn-xs pull-left" onClick={(e)=>{
                        this.props.jumpToStep(9)
                    }}>
                        <Trans>Previous</Trans>
                    </button>
                    <button className="btn btn-prev btn-xs bg-color-2 pull-right" onClick={(e)=>{
                        if(this.props.lunchObj.adultList.length>0){
                            //this.frmPrimAdultInfo.validateAll();
                           // if(!isValidForm(this.frmPrimAdultInfo)){
                               // return false;
                           // }
                           if(!this.validateFields()){
                               this.setState({hasError:true})
                               return false;
                           }
                        }                       
                        this.props.jumpToStep(11);                            
                    }}><Trans>
                        {`${this.props.lunchObj.adultList.length>0?'Continue':'No other adult'}`}
                    </Trans>
                    </button>
                    <Draft lunchObj={this.props.lunchObj} schoolInfo={this.props.schoolInfo} ref={this.childComponentRef} isDistrict={this.props.isDistrict} />
                </div>
            </div>
        </div>
    )
}
}
export default  translate("translations")(AddAdult);


// WEBPACK FOOTER //
// ./src/components/Parent/SchoolLunchBreakfastProgram/addAdult.jsx